import { Util } from "../../../../util/util";
// This before tax allocator was derived from the original code where it applies to the following coupon types:
// explicitly: QUANTITY_PRICE, MIX_AND_MATCH_PRICE
export class TargetPriceAllocator {
    allocate(params) {
        const { dItem, configuredDiscountValue } = params;
        const halfCount = dItem.halfCount ?? 1;
        const isSplitPortion = halfCount > 1;
        // Mirror how the coupon computed the total: a split item is driven to the target price from
        // what the customer is charged, less anything the target price does not buy; a whole item
        // from its covered price, floored at what the item costs. Basing the per-line amounts on the
        // covered price while the total came from the charged price would leave the difference to be
        // dumped on the last line by the distributor's rounding adjustment.
        const base = isSplitPortion ? dItem.oPrice : Math.min(dItem.cPrice, dItem.oPrice);
        const chargeableExtras = isSplitPortion
            ? (dItem.uncoveredModifierPrice ?? 0) + (dItem.upchargeModifierPrice ?? 0)
            : 0;
        const tmp = base - ((configuredDiscountValue ?? 0) / halfCount) - dItem.addOn - chargeableExtras;
        if (tmp > 0) {
            const amt = Util.Float2(tmp);
            dItem.beforeTaxDiscount += amt;
            return {
                allocated: amt,
                wantsRedistribute: 0,
                eligibleForRounding: true,
            };
        }
        return {
            allocated: 0,
            wantsRedistribute: 0,
            eligibleForRounding: false,
        };
    }
}
//# sourceMappingURL=target-price-allocator.js.map